<template>
  <div class="app-layout">
    <div class="app-layout-grid">
      <div class="list px-3 py-3" style="grid-template-rows: 125px 1fr">
        <v-card
          elevation="0"
          class="rounded-lg mb-3"
          style="border-radius: 10px"
        >
          <v-card-title>
            <v-row no-gutters>
              <v-col cols="12" class="d-flex align-center">
                <PrimaryButton
                  class="btn-box mr-4"
                  @click="$router.back()"
                  icon="mdi-arrow-left-bold"
                  iconSize="large"
                  iconClass="ma-0"
                />
                <span class="text-body-1 font-weight-bold">
                  Adhoc {{ orderModule.order }} List</span
                >
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="d-flex py-0 app-custom-search-input">
            <InputField
              class="mr-2 pb-2"
              :label="`search ${orderModule.order}`"
              prepend-inner-icon="mdi-magnify"
              outlined
              v-model="searchOrderAndDriver"
              dense
              hide-details="auto"
            >
            </InputField>
            <v-menu
              bottom
              right
              offset-y
              v-if="unassignedOrderList.length != 0"
            >
              <template v-slot:activator="{ on, attrs }">
                <PrimaryButton
                  class="pa-0 ma-0 background_color"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  icon="mdi-filter"
                  iconClass="pa-0"
                  iconColor="primary"
                  iconSize="18"
                  style="
                    height: 31px !important;
                    min-width: 31px !important;
                    width: 31px !important;
                  "
                >
                </PrimaryButton>
              </template>
              <v-list>
                <v-list-item @click="selectOrderTypeWise('Delivery')">
                  <v-list-item-title
                    >Delivery {{ orderModule.orderPlural }}</v-list-item-title
                  >
                </v-list-item>
                <v-list-item @click="selectOrderTypeWise('Pickup')">
                  <v-list-item-title
                    >Pickup {{ orderModule.orderPlural }}</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-text>
        </v-card>
        <v-card
          elevation="0"
          class="overflow-y-auto app-list app-relative background_color pr-2 rounded-lg"
          id="order-target"
        >
          <div
            class="white d-flex align-center mb-3"
            v-if="unassignedOrderList.length != 0"
          >
            <v-checkbox
              :input-value="
                selectedOrderIds.length != 0 &&
                selectedOrderIds.length ==
                  unassignedOrderList.filter(
                    (order) => order && Object.keys(order).length != 0
                  ).length
                  ? true
                  : false
              "
              hide-details="auto"
              class="ma-0 pl-5 py-2"
              @change="selectAllOrders"
            >
            </v-checkbox>
            <h5>Select All</h5>
          </div>
          <v-card
            elevation="0"
            style="overflow-y: auto; height: calc(100vh - 256px)"
            class="background_color"
          >
            <div
              class="white rounded-lg"
              v-for="(order, orderIndex) in unassignedOrderList"
              :key="orderIndex"
            >
              <div
                class="mx-3 mb-3 px-2"
                v-if="order"
                draggable
                @dragstart="orderDragStart(order.id)"
              >
                <OrderCardHolder
                  :orderDetails="order"
                  :isChecked="selectedOrderIds.indexOf(order.id) > -1"
                  @sendData="isCheckBoxSelected($event, order.id)"
                />
              </div>
            </div>
          </v-card>
        </v-card>
      </div>
      <div class="app-order-layout-grid-right d-flex flex-column py-3">
        <v-card elevation="0" class="rounded-lg mb-2">
          <v-row
            class="ma-0 pa-4 d-flex align-center justify-space-between"
            no-gutters
          >
            <!-- <v-col class="ml-2">
              <SwitchField
                v-model="roundTrip"
                class="mt-0"
                :disabled="editMode || tripList.length > 0"
                :label="`Round ${tripModule.trip}`"
              />
            </v-col> -->

            <v-col class="pr-2">
              <SelectField
                v-model="selectedProject"
                dense
                outlined
                label="Select Project"
                :itemsList="projectList"
                itemText="name"
                itemValue="id"
                @change="
                  getVehicleList();
                  getDriverList();
                "
              />
            </v-col>
            <v-col class="pr-2">
              <DatePicker
                v-model="tripDate"
                dense
                outlined
                :disabled="editMode || tripList.length > 0"
                :label="`Select ${tripModule.trip} Date *`"
                :min="returnToday()"
                :rules="[(val) => !!val || 'Trip Date is required']"
                :error-messages="formErrors.tripDate"
                @input="delete formErrors.tripDate"
                @change="
                  getOrderList();
                  getVehicleList();
                  getDriverList();
                "
              />
            </v-col>
            <v-col class="d-flex justify-end">
              <PrimaryButton
                @click="addTripToList"
                v-if="!editMode"
                :name="`Add ${tripModule.trip}`"
                icon="mdi-plus"
                iconSize="x-large"
                :disabled="tripList.length > 0 || !tripDate"
              />
            </v-col>
          </v-row>
        </v-card>
        <v-card elevation="0" class="rounded-lg h-100">
          <div class="text-right px-4 pt-4">
            <PrimaryButton
              v-if="tripList && tripList.length > 0"
              @click="submitForm()"
              name="Submit"
              :disabled="hasEmptyTrip"
            >
            </PrimaryButton>
          </div>
          <v-row class="ma-0">
            <v-col cols="12" class="order-trip-container">
              <v-expansion-panels
                v-for="(trip, tripIndex) in tripList"
                v-model="expansions[tripIndex]"
                :key="tripIndex + keyUpdate"
                flat
                class="mb-3"
              >
                <TripExpansionPanel
                  tripType="adhoc"
                  :tripErrors="formErrors[tripIndex]"
                  :tripIndex="tripIndex"
                  :warehouse-list="warehouseList"
                  :vehicle-list="vehicleList"
                  :driver-list="driverList"
                  :isEditing="editMode"
                  :isChartVisible="isChartVisible"
                  v-model="tripList[tripIndex]"
                  @removeOrderFromTrip="removeOrderFromTrip"
                  @orderDragStart="orderDragStart"
                  @dropOrder="dropOrder"
                  @removeTrip="removeTrip"
                  @removeError="removeError"
                  @getTiaRecoomendations="
                    getTiaRecoomendations($event, trip, tripIndex)
                  "
                  @viewTripOnMap="viewTripOnMap(trip.tiaData, tripIndex)"
                />
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <div>
      <v-dialog v-model="showMapDialog" eager>
        <v-card>
          <v-card-title>
            Trip On Map
            <v-spacer></v-spacer>
            <v-icon @click="showMapDialog = false">mdi-close</v-icon>
          </v-card-title>

          <v-card-text>
            <GoogleMap
              mapId="tripFormMap"
              ref="tripFormMap"
              :clusterMarkers="true"
              :hasMapInfo="true"
              :isDrawable="false"
              mapHeight="600px"
              mapWidth="100%"
            >
              <template #mapInfo>
                <MapInfo legendType="trip" />
              </template>
            </GoogleMap>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import OrderCardHolder from "@/components/ModuleBasedComponents/TripPlanning/OrderCardHolder.vue";
import TripExpansionPanel from "@/components/ModuleBasedComponents/Trip/TripExpansionPanel.vue";
import { bus } from "@/main";
import { returnToday, tiaResponseModification } from "@/utils/functions";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import { orderModule, tripModule } from "@/utils/moduleMapping";
import { orderSegment } from "@/utils/fieldConstants";

export default {
  components: {
    BaseFormLayout,
    OrderCardHolder,
    TripExpansionPanel,
    GoogleMap,
    MapInfo,
  },
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      orderSegment,
      returnToday,
      tripModule,
      orderModule,
      search: null,
      expansions: [],
      warehouseList: [],
      orderList: [],
      driverList: [],
      filterList: [],
      filters: {},
      searchOrderAndDriver: null,

      tripList: [],
      vehicleList: [],

      projectList: [],

      formErrors: [],
      tripDate: null,
      selectedProject: null,

      selectedOrderId: null,
      selectedTripIndex: null,

      selectedOrderIds: [],
      keyUpdate: 0,

      showMapDialog: false,

      mapInstance: null,

      isChartVisible: false,

      roundTrip: false,

      isDeliveryTypeChecked: false,
      isPickupTypeChecked: false,
    };
  },
  computed: {
    selectedBranch() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj.preferred_branch.id;
      } else {
        return null;
      }
    },
    unassignedOrderList() {
      if (
        this.searchOrderAndDriver &&
        this.orderList &&
        this.orderList.length > 0
      ) {
        return this.orderList.filter((obj) => {
          if (obj) {
            return Object.values(obj)
              .map((p) => {
                return typeof p === "string"
                  ? p
                      .toLocaleLowerCase()
                      .indexOf(this.searchOrderAndDriver.toLocaleLowerCase()) >
                      -1
                  : false;
              })
              .includes(true);
          }
        });
      } else {
        return this.orderList;
      }
    },
    hasEmptyTrip() {
      return this.tripList.some((trip) => {
        return trip.trip_orders.length == 0;
      });
    },
  },
  methods: {
    getWarehouseList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      return this.$api.warehouse
        .getWarehouseSelectList(params)
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectOrderTypeWise(orderType) {
      let arr = [];
      this.unassignedOrderList.forEach((order) => {
        if (order) {
          if (order.order_type == orderType) {
            arr.push(order.id);
          } else {
            let ind = this.selectedOrderIds.findIndex(
              (item) => item == order.id
            );
            if (ind > -1) {
              this.selectedOrderIds.splice(ind, 1);
            }
          }
        }
      });
      this.selectedOrderIds = [...new Set([...arr, ...this.selectedOrderIds])];
    },
    selectAllOrders(isChecked) {
      if (isChecked) {
        this.selectedOrderIds = [];
        this.unassignedOrderList.forEach((order) => {
          if (order) {
            this.selectedOrderIds.push(order.id);
          }
        });
        this.isDeliveryTypeChecked = true;
        this.isPickupTypeChecked = true;
      } else {
        this.selectedOrderIds = [];
        this.isDeliveryTypeChecked = false;
        this.isPickupTypeChecked = false;
      }
    },
    isCheckBoxSelected(isChecked, orderId) {
      if (isChecked) {
        this.selectedOrderIds.push(orderId);
      } else {
        this.selectedOrderIds.splice(this.selectedOrderIds.indexOf(orderId), 1);
      }
    },
    removeError(tripIndex, key) {
      if (this.formErrors && this.formErrors[tripIndex]) {
        if (this.formErrors[tripIndex][key]) {
          delete this.formErrors[tripIndex][key];
          this.keyUpdate++;
        }
      }
    },
    addTripToList() {
      this.tripList.push({
        trip_orders: [],
        round_trip: this.roundTrip,
      });
      this.expansions.push(0);
    },
    async removeTrip(tripIndex) {
      this.$root
        .$confirm("Delete?", "Are you sure you want to delete trip?", {
          color: "error",
        })
        .then(async (confirm) => {
          if (confirm) {
            if (
              this.tripList &&
              this.tripList[tripIndex] &&
              this.tripList[tripIndex].trip_orders &&
              this.tripList[tripIndex].trip_orders.length
            ) {
              while (this.tripList[tripIndex].trip_orders.length) {
                let orderId = this.tripList[tripIndex].trip_orders[0];
                await this.removeOrderFromTrip(orderId, tripIndex);
              }
            }
            this.tripList.splice(tripIndex, 1);
          }
        });
    },
    async removeOrderFromTrip(orderId, tripIndex) {
      let orderObject = await this.getOrderObject(orderId, tripIndex);
      let indexToPushOn = 0;
      let deleteCount = 0;
      if (orderObject && orderObject.oldIndex != undefined) {
        indexToPushOn = orderObject.oldIndex;
        deleteCount = 1;
      }
      this.orderList.splice(indexToPushOn, deleteCount, orderObject);
      if (this.formErrors && this.formErrors[tripIndex]) {
        this.formErrors.splice(tripIndex, 1);
      }
      delete this.tripList[tripIndex]["tiaData"];
      this.keyUpdate++;
      this.$forceUpdate();
    },
    orderDragStart(id, tripIndex = null) {
      this.selectedOrderId = id;
      if (tripIndex != null) {
        this.selectedTripIndex = tripIndex;
      }
    },
    async dropOrder(tripIndex, tripOrderIndex) {
      if (this.formErrors && this.formErrors[tripIndex]) {
        this.formErrors.splice(tripIndex, 1);
        this.keyUpdate++;
      }
      let orderObject;
      if (this.selectedOrderIds.length) {
        while (this.selectedOrderIds.length) {
          let orderId = this.selectedOrderIds.pop();
          orderObject = await this.getOrderObject(
            orderId,
            this.selectedTripIndex
          );
          this.moveOrderToTrip(orderObject, tripIndex, tripOrderIndex);
        }
      } else {
        orderObject = await this.getOrderObject(
          this.selectedOrderId,
          this.selectedTripIndex
        );
        this.moveOrderToTrip(orderObject, tripIndex, tripOrderIndex);
      }
      this.selectedTripIndex = null;
    },
    async getOrderObject(orderId, tripIndex) {
      if (tripIndex != null) {
        let order;
        let orderIndex = this.tripList[tripIndex].trip_orders.findIndex(
          (order) => order && order.id == orderId
        );
        order = this.tripList[tripIndex].trip_orders.splice(orderIndex, 1)[0];
        return order;
      } else {
        let orderIndex = this.orderList.findIndex(
          (order) => order && order.id == orderId
        );
        let orderObject = this.orderList.splice(orderIndex, 1, null)[0];
        orderObject.oldIndex = orderIndex;
        return orderObject;
      }
    },
    moveOrderToTrip(order, tripIndex, tripOrderIndex = 0) {
      this.tripList[tripIndex].trip_orders.splice(tripOrderIndex, 0, order);
      this.keyUpdate++;
    },
    getVehicleList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        branch: this.selectedBranch,
        // idle_vehicles: this.tripDate,
        is_active: true,
        project: this.selectedProject,
        limit: "all",
      };
      this.$api.vehicle
        .getVehicleList(params)
        .then((res) => {
          this.vehicleList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getDriverList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        branch: this.selectedBranch,
        limit: "all",
        // idle_drivers: this.tripDate,
        is_active: true,
        project: this.selectedProject,
      };
      this.$api.driver
        .getDriverList(params)
        .then((res) => {
          this.driverList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getOrderList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        status: "unassigned",
        execution_date: this.tripDate,
        branch: this.selectedBranch,
        limit: "all",
        project: this.selectedProject,
        segment: this.orderSegment.ADHOC,
        ...params,
      };
      this.$api.orderNew
        .getOrderList(params)
        .then((res) => {
          this.orderList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripObject(id) {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripObject(id)
        .then((res) => {
          this.tripList = [res.data];
          this.tripDate = res.data.trip_date;
          if (res.data.project) {
            this.getProjectList(res.data.project);
            this.selectedProject = res.data.project;
          } else {
            this.getProjectList(this.selectedBranch);
          }
          this.expansions.push(0);
          this.getOrderList();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    submitForm(tripIndex = 0) {
      let payload = {
        ...this.tripList[tripIndex],
        trip_orders: this.tripList[0].trip_orders.map((order) => order.id),
        branch: this.selectedBranch,
        trip_date: this.tripDate,
      };

      if (payload.trip_orders.length == 0) {
        bus.$emit("showToastMessage", {
          message: "Trip should have atleast one order!",
          color: "error",
        });
        return;
      }
      delete payload.tiaData;

      let finalData = {
        trip_type: this.orderSegment.ADHOC,
        payload: payload,
      };

      bus.$emit("showLoader", true);
      if (!this.editMode) {
        this.$api.trip
          .createTripObject(finalData)
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Trip created successfully!",
              color: "success",
            });
            bus.$emit("showLoader", false);
            this.$router.back();
          })
          .catch((err) => {
            this.keyUpdate++;
            this.formErrors[tripIndex] = err.data;
            bus.$emit("showLoader", false);
          });
      } else {
        this.$api.trip
          .updateTripObject(payload.id, finalData)
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Trip updated successfully!",
              color: "success",
            });
            this.$router.back();
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            this.formErrors[tripIndex] = err.data;
            this.keyUpdate++;
          });
      }
    },
    getTiaRecoomendations(recommendationSettings, tripObj, tripIndex) {
      let payload = {
        driver: tripObj.driver,
        vehicle: tripObj.vehicle,
        orders: tripObj.trip_orders.map((order) => order.id).join(","),
        round_trip: tripObj.round_trip,
        start_location_warehouse: tripObj.start_location_warehouse,
        ...recommendationSettings,
      };

      bus.$emit("showLoader", true);
      this.$api.trip
        .tiaTripRecommendation(payload)
        .then((res) => {
          let orders = [...res.data.orders];
          orders = orders.map((tiaOrder) => {
            let order = this.tripList[tripIndex].trip_orders.find(
              (order) => order.id == tiaOrder.id
            );
            order = {
              ...order,
              ...tiaOrder,
            };
            return order;
          });
          delete res.data.orders;
          this.tripList[tripIndex] = {
            ...this.tripList[tripIndex],
            trip_orders: orders,
            tiaData: tiaResponseModification(res.data),
          };
          this.keyUpdate++;
          this.isChartVisible = true;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
          this.keyUpdate++;
          this.formErrors[tripIndex] = err.data;
        });
    },
    viewTripOnMap(data) {
      this.showMapDialog = true;
      let inter = setInterval(() => {
        let map = this.$refs.tripFormMap;
        if (map && this.$refs.tripFormMap.map) {
          clearInterval(inter);
          this.$refs.tripFormMap.addGeoCollection(data.trip_route.route, true);
          this.$refs.tripFormMap.addMultipleMarkers(
            data.trip_route.pointers,
            "location_type",
            true,
            ["coordinates"]
          );
          this.$refs.tripFormMap.setMapZoom(12);
        }
      }, 100);
    },
    getProjectList(id) {
      this.$api.project
        .getProjectList({ limit: "all", branch: id })
        .then((res) => {
          this.projectList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    if (
      this.$route.params &&
      this.$route.params.id &&
      !isNaN(this.$route.params.id)
    ) {
      this.getTripObject(this.$route.params.id);
    } else {
      this.getProjectList(this.selectedBranch);
    }
    this.getWarehouseList();
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panel-content__wrap {
  padding: 0px;
}
.order-list-container {
  height: calc(100vh - 280px);
  overflow-y: auto;
}

.order-trip-container {
  height: calc(100vh - 250px);
  overflow-y: auto;
}

.expansion-container-margin {
  margin: 2px;
}

.drop-container-expansion {
  min-height: 150px;
}

.app-order-layout {
  position: absolute;
  height: 100%;
  width: 100%;
}
.app-order-layout-grid {
  display: grid;
  grid-template-columns: 350px 1fr;
  height: 100%;
  width: 100%;
}
.app-order-layout-grid-left {
  display: grid;
  grid-template-rows: 180px 1fr;
}
.app-order-layout-grid-right {
  display: flex;
  height: 100%;
  width: 100%;
}

.v-expansion-panel-header {
  min-height: 30px !important;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 3;
}
</style>
